var App = App || {};

App.Base = (function ($) {
    "use strict";

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== "undefined" ? [...SpeedbumpData.ExemptList] : [];

    function Animations() {
        var supportsCssVariables = window.CSS && window.CSS.supports && window.CSS.supports("color", "var(--primary)"),
            itemQueue = [],
            delay = 50,
            queueTimer;

        function processItemQueue() {
            if (queueTimer) {
                return;
            }

            queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    var animation = $(itemQueue).data("animation");

                    if (animation) {
                        $(itemQueue.shift())
                            .addClass("animate__" + animation)
                            .css("opacity", "1");

                        processItemQueue();
                    }

                } else {
                    window.clearInterval(queueTimer);

                    queueTimer = null;
                }
            }, delay);
        };

        if (supportsCssVariables) {
            $("html").addClass("supports-css-variables");

            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $elements.waypoint({
                        handler: function (direction) {
                            itemQueue.push(this.element);

                            processItemQueue();
                        },
                        offset: "100%"
                    });
                }
            }, 1);
        } else {
            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $.each($elements, function () {
                        $(this)
                            .css({
                                "opacity": "1",
                                "z-index": 0
                            })
                            .removeAttr("data-animation")
                            .removeClass("animate__animated");
                    });
                }
            }, 1)
        }
    };

    function BsCollapse() {
        const collapseList = document.querySelectorAll(".collapse");

        collapseList.forEach(collapse => {
            collapse.addEventListener("show.bs.collapse", e => {
                $(e.target)
                    .parent(".accordion-item")
                    .removeClass("collapsed");
            });

            collapse.addEventListener("hidden.bs.collapse", e => {
                $(e.target)
                    .parent(".accordion-item")
                    .addClass("collapsed");
            });
        });
    };

    function BsElementsEvents() {
        var $body = $("body"),
            $header = $("header"),
            $accordion = $(".collapse"),
            $offcanvas = $(".offcanvas"),
            $tab = $("[data-bs-toggle='tab']");

        $accordion
            .on("show.bs.collapse", event => {
                
            })
            .on("hidden.bs.collapse", event => {
                
            });

        $offcanvas
            .on("show.bs.offcanvas", event => {
                $header.width($header.width());
            })
            .on("shown.bs.offcanvas", event => {
                var $target = $(event.target),
                    $autofocus = $target.find("[autofocus]");

                if ($autofocus) {
                    $autofocus.trigger("focus");
                }
            })
            .on("hidden.bs.offcanvas", event => {
                $header.attr("style", null);
            });

        $tab
            .on("show.bs.tab", event => {
                
            })
            .on("shown.bs.tab", event => {
                App.Plugins.Juxtapose();
            })
            .on("hidden.bs.tab", event => {
                
            });
    }

    function BsElementsExecute(candidate) {
        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const collapse = $(candidate);
            collapse.collapse("show").parents(".accordion-item").find(`[data-bs-target=\"${candidate}\"]`).trigger("focus");
            $("html, body").animate({ scrollTop: collapse.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    };

    function BsElements() {
        bsElements = {
            accElements: [...$("[data-bs-toggle='collapse']")].filter(x => x.getAttribute("data-bs-target") != "").map(x => x.getAttribute("data-bs-target")),
            tabElements: [...$("[data-bs-toggle='tab']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        BsElementsExecute(hash);
    };

    function BsTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    };

    function ClickSupport(selector) {
        selector.on("click", function (e) {
            const href = $(this).attr("href");

            if (BsElementsExecute(href) == true)
                return false;

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        });
    };

    function GetOrdinalSuffix(num) {
        num = parseInt(num, 10);

        const lastDigit = num % 10;
        const lastTwoDigits = num % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
            return `${num}th`;
        }

        switch (lastDigit) {
            case 1:
                return `${num}st`;
            case 2:
                return `${num}nd`;
            case 3:
                return `${num}rd`;
            default:
                return `${num}th`;
        }
    };

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function IsUriSchema(href) {
        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    };

    function Modals() {
        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    };

    function ModalsExecute(href, clicked) {
        if (href !== "" && modals.includes(href))
            href = href;
        else
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal").attr("id"),
                    "content": $(result).filter(".modal").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);

                App.Base.ClickSupport(modal.find("a"));
                modal.modal("show").on("hidden.bs.modal", function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    };

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            const $this = $(this);

            $this.parent().hasClass("table-responsive") || $this.wrap("<div class='table-responsive'></div>");

            if (!$this.hasClass("table")) {
                $this.addClass("table table-borderless table-striped");

                $this
                    .children("thead")
                    .addClass("table-primary border-0");
            }

            $this.removeAttr("border cellpadding cellspacing");
        });
    };
    
    function SpeedBumpExecute(clicked) {
        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        speedBump.modal("show");
        speedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                speedBump.modal("hide");
                window.open(href);
            }
        );

        speedBump.on("hidden.bs.modal", function () {
            clicked.trigger("focus").trigger("blur");
            if (modalFlag) {
                modalParent.modal("show");
                modalFlag = false;
            }
        });

        return true;
    };

    function Year() {
        var $year = $(".year");

        $.each($year, function () {
            var $this = $(this),
                year = new Date().getFullYear();

            $this.text(year);
        });
    };

    function ZAGYear() {
        var $zagYear = $(".year-zag"),
            foundingYear = 2002;

        $.each($zagYear, function () {
            var $this = $(this),
                year = new Date().getFullYear() - foundingYear;

            $this
                .attr("data-bs-toggle", "tooltip")
                .attr("data-bs-title", "Founded in " + foundingYear + "!")
                .text(GetOrdinalSuffix(year));

            BsTooltips();
        });
    }

    return {
        Animations: Animations,
        BsCollapse: BsCollapse,
        BsElements: BsElements,
        BsElementsEvents: BsElementsEvents,
        BsTooltips: BsTooltips,
        ClickSupport: ClickSupport,
        GetUrlParameter: GetUrlParameter,
        Modals: Modals,
        RichTextResponsiveTables: RichTextResponsiveTables,
        Year: Year,
        ZAGYear: ZAGYear
    };
})(jQuery);

$(function () {
    App.Base.Animations();
    App.Base.BsCollapse();
    App.Base.BsElements();
    App.Base.BsElementsEvents();
    App.Base.BsTooltips();
    App.Base.ClickSupport($("a"));
    App.Base.Modals();
    App.Base.RichTextResponsiveTables($(".rich-text table"));
    App.Base.Year();
    App.Base.ZAGYear();
});